module.exports = [
	"bpmn:Process",
	"bpmn:StartEvent",
	"bpmn:EndEvent",
	"bpmn:ParallelGateway",
	"bpmn:Task",
	"bpmn:SequenceFlow",
	"bpmn:ExclusiveGateway"
];


//////////////////
// WEBPACK FOOTER
// ./App/Service/Bpmn2Speech/supported-elements.json
// module id = 322
// module chunks = 0